jQuery(document).ready(function ($) {

    function disableScroll() {
        $('body').addClass('body-no-scroll');
    }

    function enableScroll() {
        $('body').removeClass('body-no-scroll');
    }

    // Close nav when clicking outside
    $('body').click(function (e) {
        var target = $(e.target);

        if (target.is('.mobile-nav-button') || target.is('.bar1') || target.is('.bar2') || target.is('.bar3')) {
            return;
        } else {
            if ($(".nav-closed").hasClass("open")) {
                $(".nav-closed").removeClass("open");
                $(".bar1, .bar2, .bar3").removeClass("change");
                enableScroll();
            }
        }
    });

    // Toggle nav open/close
    $(".mobile-nav-button").click(function () {
        $(".nav-closed").toggleClass("open");
        $(".bar1, .bar2, .bar3").toggleClass("change");

        if ($(".nav-closed").hasClass("open")) {
            disableScroll();
        } else {
            enableScroll();
        }
    });

    function updateHeaderStackSpacing() {
        const topBar = $('#top-bar');
        const header = $('#header');
        const isTopBarVisible = topBar.length && topBar.is(':visible');
        const topBarHeight = isTopBarVisible ? topBar.outerHeight() : 0;
        const headerHeight = header.length ? header.outerHeight() : 0;
        const totalHeight = topBarHeight + headerHeight;

        document.documentElement.style.setProperty('--top-bar-height', `${topBarHeight}px`);
        $('.header-spacing').css('padding-top', `${totalHeight}px`);
    }

    updateHeaderStackSpacing();
    $(window).on('resize', updateHeaderStackSpacing);

    // Tactile vs desktop class detection
    /*
    $(window).on('resize', function () {
        if (window.innerWidth < 992) {
            $('#header').addClass('tactile').removeClass('desktop');
        } else {
            $('#header').addClass('desktop').removeClass('tactile');
        }
    }).resize();
    */
});
